import { config } from "@/config";
import type { BaseMessageHandler, Message } from "./types/messageDto";
import { getKey } from "./utilities";

export class InternalSubscription {
  //#region Properties: Private

  private readonly handlers: Set<BaseMessageHandler> = new Set();
  private subscriptionId: string | undefined;

  //#endregion

  //#region Properties: Public

  public readonly getSubscriptionId = () => this.subscriptionId;
  public readonly getKey = () => getKey(this.topic, this.keys);
  public readonly isEmpty = () => this.handlers.size === 0;

  //#endregion

  //#region Constructor

  constructor(
    public readonly topic: string,
    public readonly keys: string[],
    private readonly internalUnsubscribe: (
      subscription: InternalSubscription
    ) => void,
    private readonly internalSubscribe: (
      topic: string,
      keys: string[]
    ) => Promise<string | undefined>
  ) {}

  //#endregion

  //#region Methods: Private

  //#endregion

  //#region Methods: Public

  handle(message: Message): void {
    if (config.emulator) console.log("message:", message);
    this.handlers.forEach((handler) => handler(message));
  }

  async subscribe(): Promise<void> {
    this.subscriptionId = await this.internalSubscribe(this.topic, this.keys);
    if (this.subscriptionId && this.isEmpty()) {
      this.internalUnsubscribe(this);
    }
  }

  addHandler(handler: BaseMessageHandler): void {
    this.handlers.add(handler);
  }

  removeHandler(handler: BaseMessageHandler): void {
    this.handlers.delete(handler);
    if (this.subscriptionId && this.isEmpty()) {
      this.internalUnsubscribe(this);
    }
  }

  //#endregion
}
